"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostSupplyEdit = void 0;
const Base_1 = require("./Base");
exports.PostSupplyEdit = {
    url: Base_1.URL_BASE + "/SupplyEdit",
    method: "POST",
    secure: true
};
//# sourceMappingURL=PostSupplyEdit.js.map